var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-list-wrapper"},[(!_vm.isShow)?_c('div',{class:{ mask: !_vm.isShow }},[_vm._v("已隐藏")]):_vm._e(),_vm._t("name"),_c('van-grid',{attrs:{"border":false,"column-num":3}},_vm._l((_vm.datas.imageList),function(item,index){return _c('van-grid-item',{key:index},[_c('div',{staticClass:"service-card-wrapper",style:({
          backgroundImage: `url(${item.src})`,
          border: `1px solid ${item.borderColor}`,
        }),on:{"click":function($event){return _vm.handleNavigationClick({ index, item })}}},[_c('h3',{staticClass:"service-card-title",style:({
            color: item.textColor,
            fontSize: item.textSize + 'px',
          })},[_vm._v(" "+_vm._s(item.text)+" ")]),_c('span',{staticClass:"sub-text",style:({
            color: item.textColor,
            fontSize: item.subFontSize + 'px',
          })},[_vm._v(_vm._s(item.subText))]),_c('div',{staticClass:"line",style:({ backgroundColor: item.lineColor })})])])}),1),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }